import { Box, TableCell, Typography } from '@mui/material';
import DragAndDropRow from './drag-and-drop-row.tsx';
import { Moment } from 'moment';
import formatter from "../../../tools/formatter.js";
import { DebtServiceRow } from '../../services/utils/new-debt-service.utils.ts';

interface InterestRow {
  date: Moment,
  debtServiceRow: DebtServiceRow,
  showCapitalizedInterest: boolean,
}

export default function InterestRow({ 
  date, 
  debtServiceRow,
  showCapitalizedInterest,
}: InterestRow) {

  const { accInterest, capitalizedInterest, debtService, annualDS } = debtServiceRow;
  
  return (
    <DragAndDropRow 
      dragging={false} 
      onDragOver={() => {}}
      indicator="none"
    >
      <TableCell height="35px">
        <Box sx={{ fontSize: "16px", ml: 1.5 }}>
          {date.format("MM/DD/YYYY")}
        </Box>
      </TableCell>
      <TableCell align="right">-</TableCell>
      <TableCell align="right">-</TableCell>
      <TableCell align="right">{formatter.money(accInterest, false)}</TableCell>

      {showCapitalizedInterest && (
        <TableCell align="right">
          ({formatter.money(capitalizedInterest, false)})
        </TableCell>
      )}

      <TableCell align="right">{formatter.money(debtService, false)}</TableCell>
      <TableCell align="right">
        {annualDS ? formatter.money(annualDS, false) : "-"}
      </TableCell>
      <TableCell align="center"></TableCell>
    </DragAndDropRow>
  );
};
